// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { TopBarSiteWideMessageFragmentDoc } from './TopBarSiteWideMessage.fragment.generated';
import { TopBarConsultationPromptFragmentDoc } from './TopBarConsultationPrompt.fragment.generated';
export const TopBarFragmentDoc = gql`
    fragment topBar on TopBar {
  __typename
  siteWideMessage {
    ...topBarSiteWideMessage
  }
  consultationPrompt {
    ...topBarConsultationPrompt
  }
}
    ${TopBarSiteWideMessageFragmentDoc}
${TopBarConsultationPromptFragmentDoc}`;